import { buildAnchorTuples, buildScopeDimensionAnchorTuples, buildSensitiveDataAnchorTuples } from './tupleBuilders'
import type { FgaObjectType, FgaTuple } from './generated/model'

/**
 * The structural anchors an organisation needs from the moment it exists, one producer per object
 * type it anchors. They hang off the organisation alone, not off any record, so no record's sync
 * writes them. `orgBootstrap.test.ts` fails when the model gains a structural relation that is
 * neither produced here nor owned by a record.
 */
export const ORG_BOOTSTRAP_PRODUCERS = [
  { objectType: 'config_area', build: buildAnchorTuples },
  { objectType: 'sensitive_data', build: buildSensitiveDataAnchorTuples },
  { objectType: 'scope_dimension', build: buildScopeDimensionAnchorTuples },
] as const satisfies ReadonlyArray<{ objectType: FgaObjectType; build: (orgId: string) => FgaTuple[] }>

/** Ensure-only: written idempotently and never deleted. */
export const buildOrganisationBootstrapTuples = (orgId: string): FgaTuple[] =>
  ORG_BOOTSTRAP_PRODUCERS.flatMap((producer) => producer.build(orgId))
